"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_redux_1 = require("react-redux");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const MenuData_1 = __importDefault(require("./MenuData"));
const AssetActionBtn = ({ ticketId }) => {
    const { reviewRound } = (0, react_redux_1.useSelector)((state) => state.review);
    return (react_1.default.createElement(pulse_components_1.PulseMenuButton, { classes: {
            root: styles_modules_less_1.default['assets-action__menu'],
            menuCtn: styles_modules_less_1.default['action-menu__ctn'],
        }, PulseButtonProps: {
            label: '',
            icon: true,
            classes: [
                styles_modules_less_1.default['action-menu__btn'],
                styles_modules_less_1.default['action-menu__btn--disable'],
            ],
            iconClasses: {
                icon: (0, clsx_1.default)('fa-solid fa-ellipsis-v', styles_modules_less_1.default['action-menu__btn--icon']),
            },
        }, TippyProps: {
            trigger: 'click',
            appendTo: document.body,
            offset: [0, 5],
        } }, react_1.default.createElement(MenuData_1.default, { ticketId: ticketId, clientId: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.jobOfficeId, roundNumber: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundNumber, roundId: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundId })));
};
exports.default = AssetActionBtn;
